
import { useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom"

import {
    Table,
    Button,
    Tag,
    Space,
    Descriptions,
    Modal,
    Form,
    Input,
    Select,
    Popconfirm,
    notification,
    Switch,
    InputNumber,
    ColorPicker,
    Checkbox
} from 'antd'

import {
    SettingOutlined,
    DeleteOutlined
} from '@ant-design/icons'


import { DiventryMenu } from '../../Templates/Menu'
import {
    DiventryLayoutThreatDB,
    DiventryLayoutHeader,
    DiventryLayoutContent,
    DiventryLayoutFooter,
    DiventryBlock
} from '../../Templates/Layout'



const columns = [
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (text, record, index) => {
            return (<strong>{text}</strong>)
        }
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'State',
        dataIndex: 'active',
        key: 'active',
        render: (text, record, index) => {
            if (record.active === true)
                return ("Active")
            return ("Disabled")
        }
    },
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: '',
        dataIndex: 'buttons',
        key: 'buttons',
        align: "right"
    },
]

export function Subs({ kernel }) {
    const [loaded, setLoaded] = useState(true)
    const [table, setTable] = useState([])

    // for list creation
    const [isModalCreate, setIsModalCreate] = useState(false)
    const [modalMode, setModalMode] = useState(null)

    const [createForm] = Form.useForm()

    const navigate = useNavigate()

    useEffect(() => {
        async function fetch() {
            const newTable = []
            const raw = await kernel.api.get('/cyberintel/subs/list')
            if (!raw || raw.error) {
                notification.error({
                    message: `Fetch error`,
                    description: raw.error
                })
                return
            }

            const resList = raw.data?.sort((a, b) => a.order - b.order);

            for (let data of resList) {

                data.buttons = <Space.Compact size="small">
                    <Popconfirm
                        placement="left"
                        title="Delete this subscriber"
                        description="The entry will be permanently deleted"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={async () => {
                            const ret = await kernel.api.post(
                                `/cyberintel/subs/remove`,
                                { id: data.id }
                            )
                            if (ret.error) {
                                notification.error({
                                    message: 'Error deleting key',
                                    description: ret.error
                                })
                                return
                            }
                            notification.success({
                                message: 'subscriber was deleted'
                            })
                            setLoaded(!loaded)
                        }}
                    >
                        <Button><DeleteOutlined /></Button>
                    </Popconfirm>
                    <Button onClick={() => {
                        setModalMode(data.id)
                        createForm.resetFields()
                        createForm.setFieldsValue(data)
                        setIsModalCreate(true)
                    }}><SettingOutlined /></Button>
                </Space.Compact>

                newTable.push(data)
            }
            setTable(newTable)
        }
        fetch()
    }, [loaded])

    // Create handler
    const handleCreateOk = async () => {
        const data = {
            ...createForm.getFieldsValue(),
        }

        if (modalMode === null) {
            const ret = await kernel.api.post(`/cyberintel/subs/create`, data)
            if (!ret || ret.error) {
                notification.error({
                    message: `Creation error: ${ret.error}`,
                    description: Array.isArray(ret.fields) ? Object.values(ret.fields).map((el) => <div key={el}>{el}</div>) : ret.error
                })
                return
            }
            notification.success({
                message: 'New subscriber added'
            })
        }
        else {
            data.id = modalMode
            const ret = await kernel.api.post(`/cyberintel/subs/update`, data)
            if (ret.error) {
                notification.error({
                    message: `Creation error: ${ret.error}`,
                    description: Array.isArray(ret.fields) ? Object.values(ret.fields).map((el) => <div key={el}>{el}</div>) : null
                })
                return
            }
            notification.success({
                message: 'subscriber has been updated'
            })
        }

        setIsModalCreate(false)
        setLoaded(!loaded)
    }
    const handleCreateCancel = () => {
        setIsModalCreate(false)
    }

    return (
        <DiventryLayoutThreatDB>
            <DiventryMenu kernel={kernel} />
            <DiventryLayoutHeader
                title="CyberIntel Subs"
                description="Subs used by CyberIntel"
            />
            <DiventryLayoutContent>

                <Modal
                    title={modalMode === null ? "Add a CyberIntel subscriber" : "Updating CyberIntel subscriber"}
                    open={isModalCreate}
                    onOk={handleCreateOk}
                    onCancel={handleCreateCancel}
                >
                    <Form
                        // layout="vertical"
                        form={createForm}
                    >
                        <Form.Item label="Email address" name="email">
                            <Input />
                        </Form.Item>

                        <Form.Item label="Name of the subscriber" name="name">
                            <Input />
                        </Form.Item>

                        <Form.Item name="active" valuePropName="checked">
                            <Checkbox defaultChecked={true}>
                                The subscriber is active
                            </Checkbox>
                        </Form.Item>
                    </Form>
                </Modal>

                <p>
                    <Space>
                        <Button type="primary" onClick={() => {
                            createForm.resetFields()
                            setModalMode(null)
                            setIsModalCreate(true)
                        }}>
                            Add subscriber
                        </Button>

                    </Space>

                </p>
                <DiventryBlock>
                    <Table dataSource={table} columns={columns} />
                </DiventryBlock>
            </DiventryLayoutContent>

            <DiventryLayoutFooter kernel={kernel} />
        </DiventryLayoutThreatDB>
    );
}